import { useContext } from "react";
import { RootContext } from "../RootContext";

const useLanguage = () => useContext(RootContext).languageStore;

export default useLanguage;
